import * as React from 'react'

import {
    Box,
} from '@mui/material'
import { NossaSolucao } from './nossaSolucao'
import { NossosNumeros } from './nossosNumeros'
import { CarrouselClientesFalam } from './carrouselClientesFalam'
import { NossosProdutos } from './nossosProdutos'
import { Orcamento } from './orcamento'
import { Video } from './VideoContent'
import { OndeEstamos } from './ondeEstamos'
import { FooterLP } from './footerlp'
import { Letreiro } from './letreiro'

const Content: React.FC = () => {

    return (
        <Box>
            <div title='sobrelp'>
                <NossaSolucao/>
            </div>
            <Video />
            <div title='produtolp'>
                <NossosProdutos />
            </div>
             <div title='num'>
                <NossosNumeros />
            </div>
            <div style={{
                backgroundColor: "white"
            }}>
                
            </div>
            
            <div title='dep' style={{ display: "flex", justifyContent: "center" }} >
                <CarrouselClientesFalam />
            </div>
            <Letreiro />
            <div title='contlp'>
                <Orcamento />
            </div>
            <OndeEstamos />
            <FooterLP />
        </Box>
    );
}

export { Content }